import React from 'react'
import { 
  Pagination as MuiPagination, 
  PaginationProps, 
  PaginationItem, 
  PaginationItemProps 
} from '@mui/material'

const Pagination: React.FC<PaginationProps> = ({ ...props }) => (
  <MuiPagination
    shape='rounded'
    {...props}
  />
)

export {
  Pagination,
  PaginationItem,
}

export type {
  PaginationProps,
  PaginationItemProps,
}